// extracted by mini-css-extract-plugin
export default {"shareModal":"ShareModal_shareModal__KgVv7"};